import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./Context/auth-context";
import { AddToCartProvider } from "./Context/cart-context";
import { AddressContextProvider } from "./Context/address-context";
import { OrdersContextProvider } from "./Context/orders-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <OrdersContextProvider>
      <AddressContextProvider>
        <AddToCartProvider>
          <AuthContextProvider>
            <BrowserRouter>
              <App />
              <ToastContainer />
            </BrowserRouter>
          </AuthContextProvider>
        </AddToCartProvider>
      </AddressContextProvider>
    </OrdersContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
